export default [

     {
          path: '/national-risk-detection',
          name: 'NationalRiskDetection',
          component: () => import("@/views/Page/NationalRiskDetection/NationalRiskDetection.vue"),
          meta: {
               title: 'National Risk Detection',
          },
     }
];